import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import InputSlider from 'core/components/InputSlider.vue'
// Registro de componentes globais do core
import InputSelecionaBanco from 'core/components/InputSelecionaBanco.vue'
import ComprovantePagamentoModal from 'core/components/ComprovantePagamentoModal.vue'
import ResumoClienteDadosGerais from 'core/components/ResumoClienteDadosGerais.vue'
import DadosContato from 'core/components/DadosContato.vue'
import DadosEndereco from 'core/components/DadosEndereco.vue'
import DocumentoEdit from 'core/components/DocumentoEdit.vue'
import DocumentoModal from 'core/components/DocumentoModal.vue'
import AgendaParcela from 'core/components/AgendaParcela.vue'
import ImagemComFallback from 'core/components/ImagemComFallback.vue'
import ToolbarPreview from 'core/components/ToolbarPreview.vue'
import Overlay from 'core/components/Overlay.vue'
import LoadingPreview from 'core/components/LoadingPreview.vue'

const requireComponent = require.context('/', true, /\.vue$/)

requireComponent.keys().forEach(fileName => {
  if (fileName.indexOf('AppLayout') < 0) {
    const componentConfig = requireComponent(fileName)

    const componentName = upperFirst(
      camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
    )

    Vue.component(componentName, componentConfig.default || componentConfig)
  }
})

Vue.component('InputSelecionaBanco', InputSelecionaBanco)
Vue.component('InputSlider', InputSlider)
Vue.component('ComprovantePagamentoModal', ComprovantePagamentoModal)
Vue.component('ResumoClienteDadosGerais', ResumoClienteDadosGerais)
Vue.component('DadosContato', DadosContato)
Vue.component('DadosEndereco', DadosEndereco)
Vue.component('DocumentoEdit', DocumentoEdit)
Vue.component('DocumentoModal', DocumentoModal)
Vue.component('AgendaParcela', AgendaParcela)
Vue.component('ImagemComFallback', ImagemComFallback)
Vue.component('ToolbarPreview', ToolbarPreview)
Vue.component('Overlay', Overlay)
Vue.component('LoadingPreview', LoadingPreview)
